import { DropdownItem } from "../../components/ConfigPage/models/Config.interface";
import { translate } from "../../utils/translateUtils";
import { getObjectAttachment, getObjectCreator } from "../../utils/localStorage/localStorage";

export function createDropdownOption(response: any) {
    const dropdownItems: DropdownItem[] = response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
        return {
            value: item.id,
            label: translate(item.text),
            // rate: item.rate,
        };
    });
    return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
        .map(str => JSON.parse(str) as DropdownItem);
}


export function createDropdownCurrencyOption(response: any) {
    const dropdownItems: DropdownItem[] = response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
        return {
            value: item.id,
            label: translate(item.text),
            rate: item.rate,
            country: item.country_code,
        };
    });
    return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
        .map(str => JSON.parse(str) as DropdownItem);
}


export function bindCategoryDDL(categoryArray:any, display_empty:any, objRequestor:any, module?:string) {
    const isNullOrEmpty = (value: any): boolean => value == null || value == '' || value == undefined;
    //const objAttachmentString = localStorage.getItem('objAttachment');
    //const objAttachment = !isNullOrEmpty(JSON.stringify(objAttachmentString)) ? JSON.parse(JSON.stringify(objAttachmentString)) : null;
    
    //Begin,Saber , 20251031, SR - 835940 Disputed Transaction and Personal Expense category should  appear for Quick Add and Claim Items module
    let objAttr = null;
    const objAttachment: any = !isNullOrEmpty(objAttr) ? objAttr : getObjectAttachment();

    categoryArray.forEach((category:any) => {
        if (category.id == '8') /*d.text == "Disputed transaction"*/ {

            if (module && (module.toLowerCase() == "expreport" || module.toLowerCase() == "quickadd" || module.toLowerCase() == "claimitems")) {
                if (!isNullOrEmpty(objAttachment)) {
                    if (objAttachment.iS_CC != 1 || (objAttachment.iS_CC == 1 && objRequestor.country_code == 'JP')) {
                        //Country specific control where only Japan country will not have disputed transaction category in drop down category for corporate credit item
                         categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);//saber
                    }                   
                }
                else{
                    categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);//saber
                }
            }
        } //End,Saber , 20251031, SR - 835940 Disputed Transaction and Personal Expense category should  appear for Quick Add and Claim Items module
        else if (category.id == '16') /*d.text == "Per diem"*/ {

            if (module && (module.toLowerCase() == "expreport" || module.toLowerCase() == "quickadd" || module.toLowerCase() == "claimitems")) {

                if (!isNullOrEmpty(objAttachment)) {
                    if (objAttachment.iS_CC == 1) {
                        categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);
                    }
                }
            }
        }
        //Begin,Saber , 20251031, SR - 835940 Disputed Transaction and Personal Expense category should  appear for Quick Add and Claim Items module
        else if (category.id == '33') /*Personal Expense category*/ {
            //if (module && (module.toLowerCase() == "expreport")) {
            if (module && (module.toLowerCase() == "expreport" || module.toLowerCase() == "quickadd" || module.toLowerCase() == "claimitems")) {
                if (!isNullOrEmpty(objAttachment) && objAttachment.iS_CC != 1) {
                    categoryArray = categoryArray.filter((x: any) => x.id !== category.id);
                }
                else {
                    //categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);
                }
            }
            else {
                categoryArray = categoryArray.filter((x: any) => x.id !== category.id);
            }
        }//End,Saber , 20251031, SR - 835940 Disputed Transaction and Personal Expense category should  appear for Quick Add and Claim Items module
        else if (category.id == '26') /*Phone category*/ {
            if (module && (module.toLowerCase() == "expreport" || module.toLowerCase() == "quickadd" || module.toLowerCase() == "claimitems")) {
                if (!isNullOrEmpty(objAttachment) && objAttachment.iS_CC == 1 && objRequestor.country_code == 'NZ') {
                    //Country specific control where only NZ country will not have phone category in drop down category for corporate credit item
                    categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);
                }
            }
        }
        else if (category.id == '48') {
            if (module && (module.toLowerCase() != "expreport")) {
                categoryArray = categoryArray.filter((x:any)=>x.id !== category.id);
            }
        }
        else {}


    });

    return categoryArray;

}